export default "__VITE_ASSET__13330691__"